// extracted by mini-css-extract-plugin
module.exports = {"regText":"Register_regText__1OsRZ","regIcon":"Register_regIcon__-Kwcv","top":"Register_top__JY26H","login":"Register_login__2ct0J","logText":"Register_logText__nJna1"};